import { render, staticRenderFns } from "./PromoBanner.vue?vue&type=template&id=a96c3c48&scoped=true&lang=pug&"
var script = {}
import style0 from "./PromoBanner.vue?vue&type=style&index=0&id=a96c3c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96c3c48",
  null
  
)

export default component.exports